module.exports = __webpack_public_path__ + "img/director-school-icon6.7752f265.jpg";